import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=35d7fb6f&scoped=true"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"
import style0 from "./PaymentsList.vue?vue&type=style&index=0&id=35d7fb6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7fb6f",
  null
  
)

export default component.exports